"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addTokenToHeader = exports.SessionToken = void 0;
const formatToken_1 = require("../../utils/formatToken");
var SessionToken;
(function (SessionToken) {
    SessionToken["IdToken"] = "idToken";
})(SessionToken = exports.SessionToken || (exports.SessionToken = {}));
const addTokenToHeader = async (authService, storage, { headers, ...config }) => {
    const updatedHeaders = headers;
    let idToken = storage.getItem(SessionToken.IdToken);
    if (!idToken && (await authService.getIdTokenClaims())) {
        idToken = (await authService.getIdToken());
        if (idToken)
            storage.setItem(SessionToken.IdToken, idToken);
    }
    if (updatedHeaders) {
        updatedHeaders.Authorization = (0, formatToken_1.formatAuthToken)(idToken);
    }
    return {
        ...config,
        headers: idToken ? updatedHeaders : headers,
    };
};
exports.addTokenToHeader = addTokenToHeader;
